import { render } from "./adminFooter.vue?vue&type=template&id=74d9f999&scoped=true"
import script from "./adminFooter.vue?vue&type=script&lang=js"
export * from "./adminFooter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-74d9f999"

export default script